module.exports = __webpack_public_path__ + "media/open-sans/OpenSans-Italic-e959c219.eot";